import StorageServices from "../services/storageServices";

export default function useBuyerStore() {
  const store = StorageServices.get("active-buyer-store")
    ? JSON.parse(StorageServices.get("active-buyer-store"))
    : null;
  return store;
}
